import { render, staticRenderFns } from "./titletab.vue?vue&type=template&id=0f6040fb&scoped=true&"
import script from "./titletab.vue?vue&type=script&lang=js&"
export * from "./titletab.vue?vue&type=script&lang=js&"
import style0 from "./titletab.vue?vue&type=style&index=0&id=0f6040fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6040fb",
  null
  
)

export default component.exports